import colors from "styles/colors";
import { componentStyles } from "./testimonial.scss";
import DefaultProps from "./default-props";

const Testimonial = ({ backgroundColor, text, author, company }) => {
  return (
    <div className="testimonial" style={{ backgroundColor: colors[backgroundColor] }}>
      <div className="content">
        <div className="quote">{text}</div>
        <div className="author">{author}</div>
        <div className="company">{company}</div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default Testimonial;

Testimonial.defaultProps = DefaultProps;
